
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "logo",
  setup() {
    const router = useRouter();
    const handleGoToLogin = () => {
      router.push({ path: "/login" });
    };
    return {
      handleGoToLogin,
    };
  },
});
